import { capitalize } from "lodash"
import { createStore, Module, Commit } from "vuex"
import getters from "./getters"
import prompts, { State as PromptState } from "./modules/prompts"
import user, { UserState } from "./modules/user"
import categories, { CategoriesState } from "./modules/categories"

export interface State {
    prompts: PromptState
    user: UserState
    categories: CategoriesState
}

export function addVuexEntity<T>(module: Module<any, any>, name: string, opts: {defaultValue: any, beforeCall?: ({ commit, promise } : {commit: Commit, promise: Promise<any>}) => any, afterCall?: ({ commit } : {commit: Commit}) => any}, apiCall: () => any) {
    const { toast } = require("vue3-toastify")
    const mutationName = "SET_" + name.toUpperCase()
    const actionName = "get" + capitalize(name)
    const state = module.state()
    module.state = function () {
        return {
            ...state,
            [name]: opts.defaultValue || null
        }
    }
    module.mutations = {
        ...module.mutations,
        [mutationName] (state: any, value: T) {
            state[name] = value
        },
    }
    module.actions = {
        ...module.actions,
        async [actionName]({ commit } : {commit: Commit}) {
            try {
                console.log("state", {apiCall})
                const promise = apiCall()
                opts?.beforeCall?.({ commit, promise })
                const res = await promise
                commit(mutationName, res)
            } catch (e) {
                toast(actionName + " failed: " + e, { type: "error", position: "bottom-right", theme: "colored" })
                throw new Error(actionName + " failed: " + e)
            } finally {
                opts?.afterCall?.({ commit })
            }
        }
    }
}

export function addVuexEntityCRUD<T>(module: Module<any, any>, name: string, opts: {defaultValue: any}, apiCalls: {get: () => any, add: (value: any) => any, edit: (value: any) => any, del: (id: string) => any}) {
    addVuexEntity(module, name, opts, apiCalls.get)
    const pluralize = require("pluralize")
    const { toast } = require("vue3-toastify")
    const nameOne = pluralize(name, 1)
    const editMutationName = "EDIT_" + nameOne.toUpperCase()
    const addMutationName = "ADD_" + nameOne.toUpperCase()
    const delMutationName = "DEL_" + nameOne.toUpperCase()
    const addActionName = "add" + capitalize(nameOne)
    const editActionName = "edit" + capitalize(nameOne)
    const delActionName = "del" + capitalize(nameOne)

    module.mutations = {
        ...module.mutations,
        [editMutationName] (state: any, value: any) {
            state[name].forEach((nameOne: any) => {
                if (nameOne.id === value.id || nameOne._id === value._id) {
                    for (const key in value) {
                        nameOne[key] = value[key]
                    }
                }
            })
        },
        [addMutationName] (state: any, value: any) {
            state[name].push(value)
        },
        [delMutationName] (state: any, id: any) {
            state[name] = state[name].filter((nameOne: any) => nameOne.id !== id || nameOne._id !== id)
        },
    }
    module.actions = {
        ...module.actions,
        async [addActionName]({ commit } : {commit: Commit}, value) {
            try {
                const res = await apiCalls.add(value)
                commit(addMutationName, value)
            } catch (e) {
                toast(addActionName + " failed: " + e, { type: "error", position: "bottom-right", theme: "colored" })
                throw new Error(addActionName + " failed: " + e)
            }
        },
        async [editActionName]({ commit } : {commit: Commit}, value) {
            try {
                const res = await apiCalls.edit(value)
                commit(editMutationName, value)
            } catch (e) {
                toast(editActionName + " failed: " + e, { type: "error", position: "bottom-right", theme: "colored" })
                throw new Error(editActionName + " failed: " + e)
            }
        },
        async [delActionName]({ commit } : {commit: Commit}, id: string) {
            try {
                const res = await apiCalls.del(id)
                commit(delMutationName, id)
            } catch (e) {
                toast(delActionName + " failed: " + e, { type: "error", position: "bottom-right", theme: "colored" })
                throw new Error(delActionName + " failed: " + e)
            }
        },
    }
}
export default createStore({
    modules: {
        prompts,
        user,
        categories,
    },
    state: undefined,
    mutations: {
    },
    actions: {
    },
    getters
})
